import type { MeshBasicMaterialParameters } from '@anov/3d-core'

export type options = {
  radius?: number
  sphereSegments?: number
  material?: MeshBasicMaterialParameters
}
